import type { IxcInventoryV1SecurityDayKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const INVENTORY_SECURITY_DAY_BASE_PATH = getResolvedPath('/clearing/operations/inventory/balance');

export const getInventorySecurityDayPath: EntityPathBuilder<IxcInventoryV1SecurityDayKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return INVENTORY_SECURITY_DAY_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.assetId) {
        return undefined;
      }

      return getResolvedPath(`${INVENTORY_SECURITY_DAY_BASE_PATH}/$assetId`, context.keys);
    }
  }
};

export function getInventorySecurityDayDetailPath(assetId: string | undefined) {
  if (!assetId) {
    return undefined;
  }

  return getInventorySecurityDayPath({ kind: 'detail', keys: { assetId } });
}
